module.exports = __webpack_public_path__ + "img/fossil2Img3.84bc58c0.jpg";